import { render, staticRenderFns } from "./present-records.vue?vue&type=template&id=a2549126&scoped=true&"
import script from "./present-records.vue?vue&type=script&lang=js&"
export * from "./present-records.vue?vue&type=script&lang=js&"
import style0 from "./present-records.vue?vue&type=style&index=0&id=a2549126&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2549126",
  null
  
)

export default component.exports